module.exports = __webpack_public_path__ + "static/media/display-size.0ad08eda.svg";